import { create } from "zustand";
import type { IOtp } from "../types/models/otp.models.types";

export interface IAuthenticationState {
	otp: IOtp;
	password?: string;
	name?: string;
	email?: string;
	phone?: string;
}

export interface IAuthenticationStore {
	authenticationState: IAuthenticationState | null;
	setAuthenticationState: (response: IAuthenticationState) => void;
}

export const useAuthenticationStore = create<IAuthenticationStore>((set) => ({
	authenticationState: null,
	setAuthenticationState: (response) => {
		set({ authenticationState: response });
	},
}));

